import React, { useEffect } from "react";
import ChatMessage from "./ChatMessage";
import { useDispatch, useSelector } from "react-redux";
import { addMessage } from "../utils/chatSlice";
import { generateRandomName, makeRandomMessage } from "../utils/helper";
import { BsSend } from "react-icons/bs";

const LiveChat = () => {
  const dispatch = useDispatch();
  const chatMessages = useSelector((store) => store.chat.messages);
  useEffect(() => {
    const i = setInterval(() => {
      // console.log("API polling");
      dispatch(
        addMessage({
          name: generateRandomName(),
          message: makeRandomMessage(20),
        })
      );
    }, 2000);

    return () => clearInterval(i);
  });
  return (
    <>
      <div className="mt-24 ml-2 w-full h-[460px] p-2 border border-gray rounded-t-2xl bg-slate-50 overflow-y-scroll flex flex-col-reverse">
        <div>
          {chatMessages.map((c, i) => (
            <ChatMessage key={i} name={c.name} message={c.message} />
          ))}
        </div>
      </div>
      <div className="w-full p-2  ml-2  flex items-center  justify-between rounded-b-2xl  bg-slate-50 border border-gray">
        <input className="w-96" type="text" />
       <button className="px-2 ml-10 "><BsSend size={24}/> </button>
      </div>
    </>
  );
};

export default LiveChat;
